export const MESSAGES_TAB_KEY = 'messages-tab';
export const EMPTY_USER = 'User not found';
